<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/People">People</b-breadcrumb-item>
            <b-breadcrumb-item active>{{personName}}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Edit Person</div>
            <div class="card-body">
                <h4>({{personUIN}}) {{personName}}</h4>
                <div class="card">
                    <div class="card-header">
                        <ul class="card-header-tabs nav nav-tabs">
                            <li class="nav-item">
                                <a @click="currentTabComponent='ThePersonNetworkInfoForm'" class="active nav-link"
                                   data-toggle="tab"
                                   href="#">Network Information</a>
                            </li>
                            <li class="nav-item">
                                <a @click="currentTabComponent='ThePersonAddressList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Addresses</a>
                            </li>
                            <li class="nav-item">
                                <a @click="currentTabComponent='ThePersonPhoneForm'" class="nav-link" data-toggle="tab"
                                   href="#">Phone Numbers</a>
                            </li>
                            <li class="nav-item" v-if="hasApplicationRole(ApplicationRole.Administrator)">
                                <a @click="currentTabComponent='ThePersonRolesForm'" class="nav-link" data-toggle="tab"
                                   href="#">Roles</a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-container">
                        <keep-alive>
                            <component :person-id="id" v-bind:is="currentTabComponent"/>
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ThePersonNetworkInfoForm from "@/components/people/ThePersonNetworkInfoForm";
    import ThePersonAddressList from "@/components/people/ThePersonAddressList";
    import ThePersonPhoneForm from "@/components/people/ThePersonPhoneForm";
    import ThePersonRolesForm from "@/components/people/ThePersonRolesForm";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            ThePersonNetworkInfoForm,
            ThePersonAddressList,
            ThePersonPhoneForm,
            ThePersonRolesForm
        },
        data() {
            return {
                id: null,
                currentTabComponent: 'ThePersonNetworkInfoForm',
                ApplicationRole: ApplicationRole
            }
        },
        props: {
            personName: {
                type: String,
                required: false
            },
            personUIN: {
                type: String,
                required: false
            }
        },
        created() {
            this.id = this.$route.params.id;
        }
    }
</script>
